export default __webpack_public_path__ + "static/media/filter-icon-branco.a5ece93e.svg";